import React from 'react';
import { IfmsRoute } from '../../../config/types';

import Home from '../Home';
import { ISFUsageReportView } from '../../oceanImport/routes';

const routes:Array<IfmsRoute> = [
  { path: '/isf/home', component: Home},

  { path: '/isf/isfUsage', component: ISFUsageReportView },
];

export default routes;
